var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoEstrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5603 36.4248C90.2283 35.3878 89.2653 34.6828 88.1753 34.6828H58.5133L48.2803 3.5248C47.9403 2.4958 46.9813 1.7998 45.8993 1.7998C44.8173 1.7998 43.8563 2.4968 43.5183 3.5248L33.2863 34.6828H3.6243C2.5343 34.6828 1.5693 35.3878 1.2373 36.4248C0.907299 37.4638 1.2843 38.5968 2.1713 39.2298L26.1753 56.3158L16.5133 85.7258C16.1753 86.7528 16.5363 87.8818 17.4083 88.5248C18.2793 89.1658 19.4653 89.1728 20.3463 88.5478L45.8993 70.3558L71.4503 88.5468C71.8863 88.8558 72.3933 89.0118 72.9033 89.0118C73.4243 89.0118 73.9463 88.8478 74.3873 88.5238C75.2583 87.8808 75.6193 86.7528 75.2833 85.7248L65.6233 56.3148L89.6273 39.2288C90.5153 38.5968 90.8923 37.4638 90.5603 36.4248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEstrella);
export default __webpack_public_path__ + "static/media/icono-estrella.60a23d3e29c603c7a9998b52989a103d.svg";
export { ForwardRef as ReactComponent };